import { lazy } from 'react';
import { authRoles } from '@/app/auth';

const AddCompanyPage = lazy(() => import('./AddCompanyPage'));

const AddClientConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.UserManagement,
  routes: [
    {
      path: 'companies/add',
      element: <AddCompanyPage />,
    },
  ],
};

export default AddClientConfig;
